module.exports = __webpack_public_path__ + "static/OneDotCd-Italic.288a00e7.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDotCd-Italic.woff
// module id = 745
// module chunks = 114276838955818